import { CommonFlags as c, DefaultColumns, Entity, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient } from "@mcurros2/microm";
import { IconCalendarEvent } from "@tabler/icons-react";


const columns = () =>
(
    {
        c_feriado_id: new EntityColumn<string>({
            name: 'c_feriado_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Feriado Id',
            description: 'Código de feriado generado automáticamente'
        }),
        vc_nombre_feriado: new EntityColumn<string>({
            name: 'vc_nombre_feriado', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nombre',
            description: 'Nombre del feriado'
        }),
        dt_fecha_desde: new EntityColumn<Date>({
            name: 'dt_fecha_desde', type: 'datetime', flags: c.Edit, prompt: 'Fecha Desde',
            description: 'Fecha desde la cual el feriado es válido'
        }),
        dt_fecha_hasta: new EntityColumn<Date>({
            name: 'dt_fecha_hasta', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Hasta',
            description: 'Fecha hasta la cual el feriado es válido (opcional)'
        }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        feri_brwStandard: { name: 'feri_brwStandard', keyMappings: { c_feriado_id: 0 } }
    }
)


export class FeriadosDef extends EntityDefinition {

    columns = columns();
    views = views();


    constructor() {
        super('Feriados');
    }
}

export const FeriadosIcon = IconCalendarEvent;
export const FeriadosHelpText = "* Contiene de los días no laborables y feriados";

export class Feriados extends Entity<FeriadosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new FeriadosDef(), parentKeys);
        super.Form = 'AutoForm';
        super.Title = 'Feriados';
        super.Icon = FeriadosIcon;
        super.HelpText = FeriadosHelpText;
    }
}